import { CgsEvent } from '@cgs/wge';

export class BonusGameEvent extends CgsEvent {}
